import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { firstCharUpperCase } from "../../Utils/common";
import {
  hotelTouristMonthlySection,
  monthNames,
  parseJSONSafe,
} from "./visitorTrackingUtils";
import { useLanguage } from "../LanguageProvider/LanguageProvider ";
import AdminDashboard from "../../pages/Admin/AdminDashboard/AdminDashboard";
import { HomeIcon } from "../Application/ApplicationIcon";
import { BsChevronLeft } from "react-icons/bs";

const renderValue = (value) => {
  if (value === null || value === undefined || value === "") {
    return "-";
  }
  return String(value);
};

const AdminVisitorTrackingView = () => {
  const { language } = useLanguage();
  const navigate = useNavigate();
  const { state } = useLocation();
  const [formData, setFormData] = useState({});

  useEffect(() => {
    const data = state?.data;
    const indianRows = parseJSONSafe(data.indian_tourist_details);
    const foreignerRows = parseJSONSafe(data.foreigner_tourist_details);

    setFormData({
      ...data,
      report_month: `${data.report_month}`,
      report_year: `${data.report_year}`,
      indian_tourist_details: indianRows,
      foreigner_tourist_details: foreignerRows,
      monthy_total_tourists_indian: data.monthy_total_tourists_indian,
      monthy_nghts_spent_indian: data.monthy_nghts_spent_indian,
      monthy_total_tourists_foreigner: data.monthy_total_tourists_foreigner,
      monthy_nghts_spent_foreigner: data.monthy_nghts_spent_foreigner,
    });
  }, []);

  return (
    <AdminDashboard>
      <div className="aod-outer">
        <div className="ap-breadcrumb pt-2 pb-2 mb-2 adm-breadcrumb">
          <div>
            <HomeIcon />
            <b onClick={() => navigate("/admin/")}>Home / </b>
            <span>Visitor Tracking Details</span>
          </div>
        </div>
        <div className="aod-top user-aod-top mb-3">
          <div className=" text-center mb-2 adm-head">
            <button
              onClick={() => {
                navigate("/admin/visitor-tracking");
              }}
            >
              <BsChevronLeft /> Back
            </button>
          </div>
        </div>
        <div className="mb-4">
          <div className="col-md-12">
            <div className="data-wrapper">
              <div>
                <div
                  className="data-wrapper-heading-block d-flex justify-content-between align-items-center"
                  style={{ background: "#00aeef" }}
                >
                  <div className="data-wrapper-heading">
                    <h5 className="mb-0">Visitor Tracking Details</h5>
                  </div>
                </div>
                <div className="data-item-details">
                  <div className="row">
                    <div className="col-md-4 mt-2">
                      <div className="preview-data py-2 px-3 d-flex justify-content-start align-items-center">
                        <h6 className="fw-bold mb-0">Report Month:</h6>
                        <span className="mt-1 ms-2">{`${
                          monthNames[formData?.report_month]
                        } ${String(formData?.report_year)}`}</span>
                      </div>
                    </div>
                    {hotelTouristMonthlySection.map((section, sectionIndex) => {
                      return (
                        <div className="col-md-12" key={sectionIndex}>
                          <div className="preview-data py-2 px-3 d-flex justify-content-start align-items-center">
                            <h6 className="fw-bold mb-0">{firstCharUpperCase(section.title?.en)}:</h6>
                          </div>

                          <div className="py-2 px-3">
                            <div className="row">
                              {section.fields.map((field, fieldIndex) => {
                                const { label, inputProps } = field;
                                const { type } = inputProps;
                                const value = formData?.[inputProps?.name];
                                /* ================= TABLE TYPE ================= */
                                if (type === "table") {
                                  const { headers } = inputProps;
                                  const tableName = inputProps.name;

                                  let currentRows = formData[tableName] || [];

                                  if (typeof currentRows === "string") {
                                    try {
                                      const parsed = JSON.parse(currentRows);
                                      currentRows = Array.isArray(parsed)
                                        ? parsed
                                        : [];
                                    } catch (e) {
                                      currentRows = [];
                                    }
                                  }

                                  const rows =
                                    currentRows.length > 0
                                      ? currentRows
                                      : field.inputProps.rows || [];

                                  return (
                                    <div
                                      className="col-lg-12 mb-4"
                                      key={fieldIndex}
                                    >
                                      <div className="table-responsive">
                                        <table
                                          style={{
                                            width: "100%",
                                            borderCollapse: "collapse",
                                            border: "1px solid #9ca3af",
                                          }}
                                        >
                                          <thead
                                            style={{
                                              background: "#e5f5f4",
                                            }}
                                          >
                                            <tr>
                                              <th
                                                style={{
                                                  border: "1px solid #9ca3af",
                                                  padding: "8px",
                                                  textAlign: "center",
                                                  fontSize: "0.875rem",
                                                }}
                                                width="5%"
                                              >
                                                {language
                                                  ? "क्रम संख्या"
                                                  : "Sr.No."}
                                              </th>
                                              {headers.map((header, idx) => (
                                                <th
                                                  key={idx}
                                                  style={{
                                                    minWidth: "125px",
                                                    border: "1px solid #9ca3af",
                                                    padding: "8px",
                                                    textAlign: "center",
                                                    fontSize: "0.875rem",
                                                  }}
                                                  width="25%"
                                                >
                                                  {language
                                                    ? header?.label?.hi
                                                    : header?.label?.en}
                                                </th>
                                              ))}
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {rows.map((row, rowIndex) => (
                                              <tr key={rowIndex}>
                                                <td
                                                  style={{
                                                    border: "1px solid #9ca3af",
                                                    padding: "8px",
                                                    color: "#374151",
                                                    fontSize: "0.875rem",
                                                    textAlign: "center",
                                                  }}
                                                >
                                                  {rowIndex + 1}
                                                </td>
                                                {headers.map(
                                                  (header, colIndex) => {
                                                    const { name } = header;

                                                    return (
                                                      <td
                                                        key={colIndex}
                                                        style={{
                                                          border:
                                                            "1px solid #9ca3af",
                                                          padding: "8px",
                                                        }}
                                                      >
                                                        <div className="text-center">
                                                          {renderValue(
                                                            row[header.name]
                                                          )}
                                                        </div>
                                                      </td>
                                                    );
                                                  }
                                                )}
                                              </tr>
                                            ))}
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  );
                                }

                                return (
                                  <div className="col-md-4" key={fieldIndex}>
                                    <div className="preview-data py-2 px-3 d-flex justify-content-start align-items-center">
                                      <h6 className="fw-bold mb-0">
                                        {label?.en}:
                                      </h6>
                                      <span className="mt-1 ms-2">{`${renderValue(
                                        value
                                      )}`}</span>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AdminDashboard>
  );
};

export default AdminVisitorTrackingView;
